import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}selfonboarding/service`;

interface DeleteSelfOnboardingServiceCommandPayload {
  serviceRuleId?: string;
}

async function deleteSelfOnboardingServiceCommand({
  serviceRuleId,
}: DeleteSelfOnboardingServiceCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.DELETE,
      json: {
        serviceRuleId,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default deleteSelfOnboardingServiceCommand;
